module.exports = __webpack_public_path__ + "img/pic32.dacc8802.png";